import { render, staticRenderFns } from "./LuckyPup.vue?vue&type=template&id=55e2bf87&scoped=true"
import script from "./LuckyPup.vue?vue&type=script&lang=js"
export * from "./LuckyPup.vue?vue&type=script&lang=js"
import style0 from "./LuckyPup.vue?vue&type=style&index=0&id=55e2bf87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e2bf87",
  null
  
)

export default component.exports